/**
 * @author        esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   updateViewState thunk
 */

import type { Dispatch, ViewState } from '../../types'
import { updateBearing, updateLatitude, updateLongitude, updatePitch, updateZoom } from '../actions'

export const updateViewState =
  ({ bearing, latitude, longitude, pitch, zoom }: ViewState) =>
  (dispatch: Dispatch) => {
    dispatch(updateBearing(bearing))
    dispatch(updateLatitude(latitude))
    dispatch(updateLongitude(longitude))
    dispatch(updatePitch(pitch))
    dispatch(updateZoom(zoom))
  }
